import TopBar from "../components/topbar/TopBar";

export default function AppShell({ activePage, onNavigate, children }) {
  return (
    <div className="min-h-screen bg-black text-zinc-100">
      <TopBar activePage={activePage} onNavigate={onNavigate} />
      <div className="p-4">{children}</div>
    </div>
  );
}
